angular.module("app").controller("ConfigurationsPageController", [
    '$scope',
    'preloadedConfigs',
    'preloadedConfigTypes',
    'configsService',
    'errorHandler',
    'logger',
    'deepCompare',
    '$window',
    '$uibModal',
    'settingsService',
    '$filter',
    function ($scope, preloadedConfigs, preloadedConfigTypes, configsService, errorHandler, logger, deepCompare, $window, $modal, settingsService, $filter) {

        var pristineConfig = {},
            openedItemsHistory = [],
            onlyChildes = $filter("onlyChildes"),
            init,
            currentEditing = {
                menu: {}
            };

        $scope.settings = settingsService.getSettings();
        $scope.treeOptions = {
            showAllTreeElements: $scope.settings && $scope.settings.allowActions && ($scope.settings.allowActions.indexOf("configTreeChange") + $scope.settings.allowActions.indexOf("configTreeAdd") > -2),
            canAdd: $scope.settings && $scope.settings.allowActions && $scope.settings.allowActions.indexOf("configTreeAdd") > -1,
            canChange: $scope.settings && $scope.settings.allowActions && $scope.settings.allowActions.indexOf("configTreeChange") > -1
        };
        $scope.menuItems = angular.copy(preloadedConfigs);
        $scope.configTypes = angular.copy(preloadedConfigTypes);
        $scope.dragControlListeners = {
            orderChanged: function (data) {
                $scope.changes = data;
                $scope.notAllowed = false;
            },
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.sortableScope.modelValue === destSortableScope.modelValue;
            },
            dragStart: function (data) {
                initValue(data);
            },
            dragEnd: function () {
                if ($scope.changes && $scope.changes.source && $scope.changes.dest)
                    if ($scope.changes.source.index != $scope.changes.dest.index && !$scope.notAllowed) {
                        setSort($scope.changes.source.index, $scope.changes.dest.index);
                    }
            }
        };

        $scope.openContent = function (menu) {

            if ($scope.treeOptions.showAllTreeElements) {
                return
            }

            var index = openedItemsHistory.indexOf(menu);

            if (index < 0) {
                openedItemsHistory.length > 0 && closeSiblings(menu);
                openedItemsHistory.push(menu)
            } else {
                openedItemsHistory.splice(index, openedItemsHistory.length - index);
            }

            (init = function (menu) {
                $scope.allowOrder = menu.allowOrder;
                $scope.allowUpload = menu.allowUpload;
                $scope.configData = group(angular.copy(openedItemsHistory[openedItemsHistory.length - 1]));
                pristineConfig = angular.copy($scope.configData);
                currentEditing.menu = menu;
            })(menu);

        };

        $scope.submitConfigForm = function () {
            var changes = deepCompare.getChanges(pristineConfig.child, $scope.configData.child, "configSkinId");
            var groups = Object.keys(changes);
            if (!groups.length) {
                return
            } else {
                var requestData = {};
                for (var i = 0; i < groups.length; i++) {
                    for (var prop in changes[groups[i]]) {
                        requestData[changes[groups[i]][prop]["configSkinId"]] = changes[groups[i]][prop]
                    }
                }
            }
            configsService.updateConfigByConfigSkinId(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        setChanges();
                        pristineConfig = angular.copy($scope.configData);
                        logger.logSuccess("global.updated");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.hasNestedChild = function (data) {
            var i = 0;

            if ($scope.treeOptions.showAllTreeElements) {
                return !!data.child
            } else {
                data = data.child || [];
                while (data[i]) {
                    if (!!data[i].child && data[i].child.length) {
                        return true
                    }
                    i++;
                }
            }
            return false
        };

        $scope.getConfigsList = function () {
            return $scope.configData && $scope.configData.child
        };

        $scope.generateJs = function () {
            configsService.generateJs().then(
                function (response) {
                    if (response.status == "ok") {
                        var modalInstance;
                        logger.logSuccess("global.generated");

                        response.link && (modalInstance = $modal.open({
                            templateUrl: "views/templates/modals/openGeneratedWindow.html",
                            controller: "GenerateJsModalPageController",
                            resolve: {
                                linkToLoad: function () {
                                    return response.link
                                }
                            }
                        }));
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.needToShow = function (menu) {

            if ($scope.treeOptions.showAllTreeElements) {
                return true
            }

            var child = angular.copy(menu.child),
                arr = [],
                i = 0;

            while (child[i]) {
                if (!child[i].child) {
                    return true
                } else {
                    child[i].child && child[i].child.length && (arr = arr.concat(angular.copy(child[i].child)))
                }
                i++;
            }

            if (!!arr.length) {
                return $scope.needToShow({child: arr})
            }

            return false
        };

        $scope.addConfig = function (menu) {
            menu.adding = true;
            menu.addingItem = {
                parent_id: menu.id
            }
        };

        $scope.editConfig = function (menu) {
            menu.adding = true;
            menu.editing = true;
            menu.addingItem = {
                id: menu.id,
                key: menu.key,
                value_type: menu.value_type,
                static: !!+menu.static,
                skin_dev: !!+menu.skin_dev,
                skin_admin: !!+menu.skin_admin,
                description: menu.description
            }
        };

        $scope.submitAddConfigForm = function (itemToCreate) {
            var requestData = angular.copy(itemToCreate);

            if (!!requestData.static) {
                delete requestData.skin_admin;
                delete requestData.skin_dev;
            } else {
                delete requestData.static
            }

            if (requestData.value_type == 'group') {
                delete requestData.value
            }

            configsService.createConfig(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.configCreated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.submitEditConfigForm = function (item) {
            var requestData = angular.copy(item);

            if (!!requestData.static) {
                delete requestData.skin_admin;
                delete requestData.skin_dev;
            } else {
                delete requestData.static
            }
            if (requestData.value_type == 'group') {
                delete requestData.value
            }

            configsService.editConfig(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        setChanges();
                        logger.logSuccess("global.configUpdated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.addConfigGroup = function () {
            $scope.configGroup = {
                addingItem: {
                    parent_id: 0
                }
            }
        };

        $scope.revertToDefault = function () {
            init && init(currentEditing.menu);
        };

        $scope.showRevertButton = function () {
            if (!$scope.configData ||
                !pristineConfig ||
                ((pristineConfig && !pristineConfig.child) || ($scope.configData && !$scope.configData.child))
            ) {
                return
            }
            return !!deepCompare.getChanges(pristineConfig.child, $scope.configData.child, "configSkinId")
        };


        $scope.applyConfigs = function () {
            configsService.applyConfigs().then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.configApplied");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function closeSiblings(menu) {
            var i = 0, orderLevel = menu.orderLevel;
            while (openedItemsHistory[i]) {
                if (openedItemsHistory[i].orderLevel == orderLevel) {
                    return openedItemsHistory.splice(i, openedItemsHistory.length - i);
                }
                i++;
            }
        }

        function group(childes) {
            var childesToShow = (!!childes && !!childes.child) ? onlyChildes(childes.child) : [],
                returnObj = {},
                i = 0;

            while (childesToShow[i]) {
                returnObj[childesToShow[i].mark || "null"] = returnObj[childesToShow[i].mark || "null"] || [];
                returnObj[childesToShow[i].mark || "null"].push(childesToShow[i]);
                i++;
            }
            if (!!childes) {
                return {child: returnObj, static: childes && childes.static}
            }
        }

        function initValue (data) {
            $scope.sourceReference = data.source.sortableScope.modelValue;
            $scope.currentOrderingArray = angular.copy(data.source.sortableScope.modelValue);
        }

        function setSort () {
            var returnArr = angular.copy($scope.sourceReference);

            setOrder(returnArr);
            for (var prop in $scope.configData.child) {
                if ($scope.sourceReference === $scope.configData.child[prop]) {
                    return $scope.configData.child[prop] = returnArr;
                }
            }
        }

        function setOrder(arr) {
            var i = 0;
            while(arr[i]) {
                arr[i].order = i + 1;
                i++;
            }
        }

        function setChanges () {
            configsService.getConfigsMenu().then(
                function (response) {
                    $scope.menuItems = angular.copy(response.configs);
                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            )
        }

    }
]);